import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { lastValueFrom } from 'rxjs';
import { IdentityBrandingService } from 'src/app/services/identityBranding.service';
import { LoggingService } from 'src/app/services/logging.service';
import { BrandingDisableModal } from '../branding-disable/branding-disable.modal';
import { PrivateWhatsappModal } from '../branding-editWhatsapp/branding-editWhatsapp.modal';
import { ToastService } from 'src/app/services/toast.service';
import { AppComponent } from 'src/app/components/app/app.component';
import { FormControl } from '@angular/forms';
import { ForbiddenWordValidator } from 'src/app/directives/forbidden-word-validator.directive';
import { User } from 'src/app/models/user';
import { CustomUrlsAvatarMenuKnowledgebaseModal, customUrlsAvatarMenuModalOptions } from 'src/app/modals/custom-urls-avatarmenu/custom-urls-avatarmenu-knowledgebase-modal.component';
import { PKIUrls } from 'src/app/constants/pkiurls.constants';
import { CustomUrlsAvatarMenuSupportModal } from 'src/app/modals/custom-urls-avatarmenu/custom-urls-avatarmenu-support-modal.component';
import { CustomUrlsAvatarMenuReleaseNotesModal } from 'src/app/modals/custom-urls-avatarmenu/custom-urls-avatarmenu-releasenotes-modal.component';

@Component({
  templateUrl: './branding-tab-general.component.html'
})
export class BrandingTabGeneralComponent {
  data: any;
  generalBranding!: any;
  knowledgebase: boolean = false;
  knowledgebaseUrl: string = "";
  support: boolean = false;
  supportUrl: string = "";
  releasenotes: boolean = false;
  releasenotesUrl: string = "";
  enablePrivateWhatsapp: boolean = false;
  translations = <any>{};
  domainUrlControl: FormControl;
  identityUrlControl: FormControl;
  isUserAllowedToEditUrl: boolean = false;
  protected _user: User = new User;
  public get user(): User {
    return this._user;
  }
  @Input('user') set user(value: User) {
    this._user = value;
  }

  @Input('brandingStatus') brandingStatus: boolean = false;
  @Input('ssoDisabled') ssoDisabled: boolean = false;
  @Input('ssorequired') ssoRequired: boolean = false;
  @Input('brandingEditable') brandingEditable: boolean = false;
  @Input() premiumRequired: boolean = false;
  @Output('updateBrandingStatus') updateBrandingStatus: EventEmitter<string> = new EventEmitter<string>();
  @Output('updateSso') updateSso: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output('updateBrandingEditable') updateBrandingEditable: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(protected identityBrandingService: IdentityBrandingService, protected loggingService: LoggingService, protected modalService: NgbModal,
    protected toastService: ToastService, protected appComponent: AppComponent) {
    this.domainUrlControl = new FormControl("", [ForbiddenWordValidator("http://"), ForbiddenWordValidator("https://")]);
    this.identityUrlControl = new FormControl("", [ForbiddenWordValidator("http://"), ForbiddenWordValidator("https://")]);
  }

  /**
   * Verifies length of sms sender name since this field has an implicit max lenght.
   * This is used to display how long it is and should be.
   */
  get getLengthOfSmsSenderName(): number {
    return this.generalBranding?.smsSenderName?.length ?? 0;
  }
  /**
   * Verifies length of sms sender name and returns whether it (ALMOST or) EXCEEDS the limit
   * This then displays a warning to notify users since it is IMPLICIT max length
   */
  get doesSmsSenderNameExceedLimit(): boolean {
    return this.getLengthOfSmsSenderName >= 11;
  }
  /**
   * Display property for the length warning :)
   */
  get cutShortSmsName(): string {
    return this.getLengthOfSmsSenderName != 0 ? this.generalBranding?.smsSenderName.substring(0, 11) : "";
  }
  setUrlControlsEnabled(enabled: boolean) {
    if (this.domainUrlControl && this.identityUrlControl) {
      if (enabled) {
        this.domainUrlControl.enable();
        this.identityUrlControl.enable();
      } else {
        this.domainUrlControl.disable();
        this.identityUrlControl.disable();
      }
    }

  }
  getBrandingGeneral(org: any) { }

  updateValues(key: string, event: any) {
    this.generalBranding[key] = (event.target as HTMLInputElement).value;
  }

  updateBrandingGeneral() { }

  updateUrls() { }

  setBrandingStatus() {
    if (!this.brandingStatus) this.updateBrandingStatus.emit('enable');
    else {
      this.disableBranding();
    }
  }

  private disableBranding() {
    let ngbModalOptions: NgbModalOptions = {
      keyboard: false,
      centered: true,
      size: 'md',
      windowClass: 'dialog-bg-white',

    };
    const enableBrandingModalRef = this.modalService.open(BrandingDisableModal, ngbModalOptions);
    enableBrandingModalRef.componentInstance.disableBranding.subscribe(() => {
      enableBrandingModalRef.close();
      this.updateBrandingStatus.emit('disable');
    });
    enableBrandingModalRef.componentInstance.close.subscribe(() => {
      enableBrandingModalRef.close();
      this.brandingStatus = true;
    });
  }

  editPrivateWhatsapp() {
    let ngbModalOptions: NgbModalOptions = {
      keyboard: false,
      centered: true,
      size: 'md',
      windowClass: 'dialog-bg-white',

    };
    const whatsappModal = this.modalService.open(PrivateWhatsappModal, ngbModalOptions);
    whatsappModal.componentInstance.whatsappNumber = this.generalBranding.whatsappNumber;
    whatsappModal.componentInstance.setWhatsappForBusiness.subscribe((data: string) => {
      this.generalBranding.whatsappNumber = data;
      whatsappModal.close();
      this.updateBrandingGeneral();
    });
    whatsappModal.componentInstance.close.subscribe(() => {
      if (this.generalBranding.whatsappNumber !== null) this.enablePrivateWhatsapp = true;
      else this.enablePrivateWhatsapp = false;
      whatsappModal.close();
    });
  }

  toggleWhatsapp() {
    if (this.enablePrivateWhatsapp) {
      this.generalBranding.whatsappNumber = null;
      this.updateBrandingGeneral();
    }
    else this.editPrivateWhatsapp();
  }

  updateToggleSwitches(key: string, event: any) {
    this.generalBranding[key] = (event.target as HTMLInputElement).checked;
    this.updateBrandingGeneral();
  }

  openCustomUrlsAvatarMenuKnowledgebaseModal(): void {
    let customUrlsAvatarMenuKnowledgebaseModal = this.modalService.open(CustomUrlsAvatarMenuKnowledgebaseModal, customUrlsAvatarMenuModalOptions);
    customUrlsAvatarMenuKnowledgebaseModal.componentInstance.organisationSettings = this.generalBranding;
    customUrlsAvatarMenuKnowledgebaseModal.componentInstance.setKnowledgebaseUrl.subscribe((data: string) => {
      this.generalBranding.knowledgebaseUrl = data;
      customUrlsAvatarMenuKnowledgebaseModal.close();
      this.updateBrandingGeneral();
    });
  }

  openCustomUrlsAvatarMenuSupportModal(): void {
    let customUrlsAvatarMenuSupportModal = this.modalService.open(CustomUrlsAvatarMenuSupportModal, customUrlsAvatarMenuModalOptions);
    customUrlsAvatarMenuSupportModal.componentInstance.organisationSettings = this.generalBranding;
    customUrlsAvatarMenuSupportModal.componentInstance.setSupportUrl.subscribe((data: string) => {
      this.generalBranding.SupportUrl = data;
      customUrlsAvatarMenuSupportModal.close();
      this.updateBrandingGeneral();
    });
  }

  openCustomUrlsAvatarMenuReleaseNotesModal(): void {
    let customUrlsAvatarMenuReleaseNotesModal = this.modalService.open(CustomUrlsAvatarMenuReleaseNotesModal, customUrlsAvatarMenuModalOptions);
    customUrlsAvatarMenuReleaseNotesModal.componentInstance.organisationSettings = this.generalBranding;
    customUrlsAvatarMenuReleaseNotesModal.componentInstance.setReleaseNotesUrl.subscribe((data: string) => {
      this.generalBranding.ReleaseNotesUrl = data;
      customUrlsAvatarMenuReleaseNotesModal.close();
      this.updateBrandingGeneral();
    });
  }
}

@Component({
  selector: 'app-branding-tab-general-organisation',
  templateUrl: './branding-tab-general.component.html'
})
export class BrandingTabGeneralOrganisationComponent extends BrandingTabGeneralComponent {

  private _organisation!: any;
  get organisation(): any {
    return this._organisation;
  }
  @Input('Organisation') set organisation(val: any) {
    this._organisation = val;
    if (this._organisation) {
      this.getBrandingGeneral(val);
    }
  }
  protected override _user!: User;
  override get user(): User {
    return this._user;
  }
  @Input('user') override set user(userVal: User) {
    this._user = userVal;
    this.isUserAllowedToEditUrl = this._user.isWhitelabelAdmin || this._user.isSystemAdmin;
    this.setUrlControlsEnabled(this.isUserAllowedToEditUrl); // <-- needs enabled bool as input
  }

  constructor(protected override identityBrandingService: IdentityBrandingService, protected override loggingService: LoggingService, protected override modalService: NgbModal,
    protected override toastService: ToastService, protected override appComponent: AppComponent) {
    super(identityBrandingService, loggingService, modalService, toastService, appComponent);
  }



  override getBrandingGeneral(org: any) {
    this.identityBrandingService.getGeneralOrganisation(org.guid)
      .then((response) => {
        lastValueFrom(response)
          .then((value: any) => {
            this.generalBranding = value;
            this.knowledgebase = this.generalBranding.knowledgebase != null ? JSON.parse(this.generalBranding.knowledgebase) : false;
            this.knowledgebaseUrl = this.generalBranding.knowledgebaseurl != null ? JSON.parse(this.generalBranding.knowledgebaseurl) : PKIUrls.KnowledgeBase;
            this.support = this.generalBranding.support != null ? JSON.parse(this.generalBranding.support) : false;
            this.supportUrl = this.generalBranding.supporturl != null ? JSON.parse(this.generalBranding.supporturl) : PKIUrls.CreateSupportTicket;
            this.releasenotes = this.generalBranding.releasenotes != null ? JSON.parse(this.generalBranding.releasenotes) : false;
            this.releasenotesUrl = this.generalBranding.releasenotesurl != null ? JSON.parse(this.generalBranding.releasenotesurl) : PKIUrls.PatchNotes;
            this.enablePrivateWhatsapp = this.generalBranding.whatsappNumber != null ? true : false;
            this.updateBrandingEditable.emit(this.generalBranding && this.generalBranding.frontendDomain !== null && this.generalBranding.frontendDomain !== undefined && this.generalBranding.identityDomain !== null && this.generalBranding.identityDomain !== undefined)
          })
          .catch(error => this.loggingService.logException(error));
      }).catch(error => this.loggingService.logException(error));
  }

  override updateBrandingGeneral() {
    this.identityBrandingService.postGeneralOrganisation(this._organisation.guid, this.generalBranding)
      .then(value => {
        lastValueFrom(value).then((data: any) => {
          this.toastService.showSaved();
          this.appComponent.knowledgebase = this.knowledgebase;
          this.appComponent.knowledgebaseUrl = this.knowledgebaseUrl;
          this.appComponent.support = this.support;
          this.appComponent.supportUrl = this.supportUrl;
          this.appComponent.releasenotes = this.releasenotes;
          this.appComponent.releasenotesUrl = this.releasenotesUrl;
          this.getBrandingGeneral(this._organisation);
        }).catch((error) => this.loggingService.logException(error));
      })
      .catch((error) => this.loggingService.logException(error));
  }

  override updateUrls() {
    // must be valid else it breaks:
    if (!this.domainUrlControl.valid || !this.identityUrlControl.valid) {
      this.toastService.showErrorByKey("Toasts.UrlsMustAlwaysBeSavedValid");

      return
    }
    this.identityBrandingService.postUrlsOrganisation(this._organisation.guid, { "FrontendDomain": this.generalBranding.frontendDomain, "IdentityDomain": this.generalBranding.identityDomain })
      .then(value => {
        lastValueFrom(value).then(value => {
          this.toastService.showSaved();
          this.updateBrandingEditable.emit(this.generalBranding && this.generalBranding.frontendDomain !== null && this.generalBranding.frontendDomain !== undefined && this.generalBranding.identityDomain !== null && this.generalBranding.identityDomain !== undefined)
        })
          .catch((error) => this.loggingService.logException(error));
      })
      .catch((error) => this.loggingService.logException(error));
  }
}

@Component({
  selector: 'app-branding-tab-general-whitelabel',
  templateUrl: './branding-tab-general.component.html'
})
export class BrandingTabGeneralWhiteLabelComponent extends BrandingTabGeneralComponent {

  private _whiteLabel!: any;
  get whiteLabel(): any {
    return this._whiteLabel;
  }
  @Input('whiteLabel') set whiteLabel(val: any) {
    this._whiteLabel = val;
    if (this._whiteLabel) {
      this.getBrandingGeneral(val);
    }
  }
  protected override _user!: User;
  override get user(): User {
    return this._user;
  }
  @Input('user') override set user(userVal: User) {
    this._user = userVal;
    this.isUserAllowedToEditUrl = this._user.isSystemAdmin;
    this.setUrlControlsEnabled(this.isUserAllowedToEditUrl); // <-- needs enabled bool as input
  }



  constructor(protected override identityBrandingService: IdentityBrandingService, protected override loggingService: LoggingService, protected override modalService: NgbModal,
    protected override toastService: ToastService, protected override appComponent: AppComponent) {
    super(identityBrandingService, loggingService, modalService, toastService, appComponent);
  }

  override getBrandingGeneral(wl: any) {
    this.identityBrandingService.getGeneralWhiteLabel(wl.guid)
      .then((response) => {
        lastValueFrom(response)
          .then((value: any) => {
            this.generalBranding = value;
            this.knowledgebase = this.generalBranding.knowledgebase != null ? JSON.parse(this.generalBranding.knowledgebase) : true;
            this.knowledgebaseUrl = this.generalBranding.knowledgebaseurl != null ? JSON.parse(this.generalBranding.knowledgebaseurl) : PKIUrls.KnowledgeBase;
            this.support = this.generalBranding.support != null ? JSON.parse(this.generalBranding.support) : true;
            this.supportUrl = this.generalBranding.supporturl != null ? JSON.parse(this.generalBranding.supporturl) : PKIUrls.CreateSupportTicket;
            this.releasenotes = this.generalBranding.releasenotes != null ? JSON.parse(this.generalBranding.releasenotes) : true;
            this.releasenotesUrl = this.generalBranding.releasenotesurl != null ? JSON.parse(this.generalBranding.releasenotesurl) : PKIUrls.PatchNotes;
            this.enablePrivateWhatsapp = this.generalBranding.whatsappNumber != null ? true : false;
            this.updateBrandingEditable.emit(this.generalBranding && this.generalBranding.frontendDomain !== null && this.generalBranding.frontendDomain !== undefined && this.generalBranding.identityDomain !== null && this.generalBranding.identityDomain !== undefined)
          })
          .catch(error => this.loggingService.logException(error));
      }).catch(error => this.loggingService.logException(error));
  }

  override updateBrandingGeneral() {
    this.identityBrandingService.postGeneralWhiteLabel(this.whiteLabel.guid, this.generalBranding)
      .then(value => {
        lastValueFrom(value).then((data: any) => {
          this.toastService.showSaved();
          this.appComponent.knowledgebase = this.knowledgebase;
          this.appComponent.support = this.support;
          this.appComponent.releasenotes = this.releasenotes;
          this.getBrandingGeneral(this.whiteLabel);
        }).catch((error) => this.loggingService.logException(error));
      })
      .catch((error) => this.loggingService.logException(error));
  }

  override updateUrls() {
    // must be valid else it breaks:
    if (!this.domainUrlControl.valid || !this.identityUrlControl.valid) {
      this.toastService.showErrorByKey("Toasts.UrlsMustAlwaysBeSavedValid");

      return
    }
    this.identityBrandingService.postUrlsWhiteLabel(this.whiteLabel.guid, { "FrontendDomain": this.generalBranding.frontendDomain, "IdentityDomain": this.generalBranding.identityDomain })
      .then(value => {
        lastValueFrom(value).then(value => {
          this.updateBrandingEditable.emit(this.generalBranding && this.generalBranding.frontendDomain !== null && this.generalBranding.frontendDomain !== undefined && this.generalBranding.identityDomain !== null && this.generalBranding.identityDomain !== undefined)
          this.toastService.showSaved();
        })
          .catch((error) => this.loggingService.logException(error));
      })
      .catch((error) => this.loggingService.logException(error));
  }
}

@Component({
  selector: 'app-branding-tab-general-system',
  templateUrl: './branding-tab-general.component.html'
})
export class BrandingTabGeneralSystemComponent extends BrandingTabGeneralComponent {

  private _system!: any;
  get system(): any {
    return this._system;
  }
  @Input('system') set system(val: any) {
    this._system = val;
    if (this._system) {
      this.getBrandingGeneral(val);
    }
  }
  protected override _user!: User;
  override get user(): User {
    return this._user;
  }
  @Input('user') override set user(userVal: User) {
    this._user = userVal;
    this.isUserAllowedToEditUrl = this._user.isSystemAdmin;
    this.setUrlControlsEnabled(this.isUserAllowedToEditUrl); // <-- needs enabled bool as input
  }


  constructor(protected override identityBrandingService: IdentityBrandingService, protected override loggingService: LoggingService, protected override modalService: NgbModal,
    protected override toastService: ToastService, protected override appComponent: AppComponent) {
    super(identityBrandingService, loggingService, modalService, toastService, appComponent);
  }

  override getBrandingGeneral(sys: any) {
    this.identityBrandingService.getGeneralSystem(sys.guid)
      .then((response) => {
        lastValueFrom(response)
          .then((value: any) => {
            this.generalBranding = value;
            this.knowledgebase = this.generalBranding.knowledgebase != null ? JSON.parse(this.generalBranding.knowledgebase) : true;
            this.knowledgebaseUrl = this.generalBranding.knowledgebaseurl != null ? JSON.parse(this.generalBranding.knowledgebaseurl) : PKIUrls.KnowledgeBase;
            this.support = this.generalBranding.support != null ? JSON.parse(this.generalBranding.support) : true;
            this.supportUrl = this.generalBranding.supporturl != null ? JSON.parse(this.generalBranding.supporturl) : PKIUrls.CreateSupportTicket;
            this.releasenotes = this.generalBranding.releasenotes != null ? JSON.parse(this.generalBranding.releasenotes) : true;
            this.releasenotesUrl = this.generalBranding.releasenotesurl != null ? JSON.parse(this.generalBranding.releasenotesurl) : PKIUrls.PatchNotes;
            this.enablePrivateWhatsapp = this.generalBranding.whatsappNumber != null ? true : false;
            this.updateBrandingEditable.emit(this.generalBranding && this.generalBranding.frontendDomain !== null && this.generalBranding.frontendDomain !== undefined && this.generalBranding.identityDomain !== null && this.generalBranding.identityDomain !== undefined)
          })
          .catch(error => this.loggingService.logException(error));
      }).catch(error => this.loggingService.logException(error));
  }

  override updateBrandingGeneral() {
    this.identityBrandingService.postGeneralSystem(this.system.guid, this.generalBranding)
      .then(value => {
        lastValueFrom(value).then((data: any) => {
          this.toastService.showSaved();
          this.appComponent.knowledgebase = this.knowledgebase;
          this.appComponent.support = this.support;
          this.appComponent.releasenotes = this.releasenotes;
          this.getBrandingGeneral(this.system);
        }).catch((error) => this.loggingService.logException(error));
      })
      .catch((error) => this.loggingService.logException(error));
  }

  override updateUrls() {
    // must be valid else it breaks:
    if (!this.domainUrlControl.valid || !this.identityUrlControl.valid) {
      this.toastService.showErrorByKey("Toasts.UrlsMustAlwaysBeSavedValid");

      return
    }
    this.identityBrandingService.postUrlsSystem(this.system.guid, { "FrontendDomain": this.generalBranding.frontendDomain, "IdentityDomain": this.generalBranding.identityDomain })
      .then(value => {
        lastValueFrom(value).then(value => {
          this.updateBrandingEditable.emit(this.generalBranding && this.generalBranding.frontendDomain !== null && this.generalBranding.frontendDomain !== undefined && this.generalBranding.identityDomain !== null && this.generalBranding.identityDomain !== undefined)
          this.toastService.showSaved();
        })
          .catch((error) => this.loggingService.logException(error));
      })
      .catch((error) => this.loggingService.logException(error));
  }
}